import * as React from 'react';
import { Box, BoxStyle } from '../../components/Box';
import Section from '../../components/Section';
import { Guide, getDose } from '../../guide';

type Props = {
  guide: Guide;
};

export default function BasicInfoSection(props: Props) {
  if (!props.guide.company) {
    return (
      <Section
        title={`About ${props.guide.user.name}`}
        bodyStyle={BoxStyle.Padded}
      >
        <blockquote className="lh-copy">
          This guide has been created by {props.guide.user.name}
        </blockquote>
      </Section>
    );
  }

  return (
    <Section
      title={`About ${props.guide.company.name}`}
      bodyStyle={BoxStyle.Padded}
    >
      <blockquote className="lh-copy">
        {props.guide.company.description_text}
      </blockquote>
    </Section>
  );
}
